import { CommonModule, DatePipe } from '@angular/common';
import { APP_INITIALIZER, CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatTabsModule } from '@angular/material/tabs';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgbActiveModal, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ClipboardModule } from 'ngx-clipboard';
import { HighlightModule, HIGHLIGHT_OPTIONS } from 'ngx-highlightjs';
import { ToastrModule } from 'ngx-toastr';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { FooterComponent } from './components/footer/footer.component';
import { LandingHeaderComponent } from './components/landing-header/landing-header.component';
import { LandingHerosComponent } from './components/landing-heros/landing-heros.component';
import { LandingComponent } from './components/landing/landing.component';
import { LayoutComponent } from './components/layout/layout.component';
import { ProductDetailsComponent } from './components/product-details/product-details.component';
import { SocialMediaFooterComponent } from './components/social-media-footer/social-media-footer.component';
import { HomeModule } from './Modules/home/home.module';
import { InformateModule } from './Modules/informate/informate.module';
import { SettingsModule } from './Modules/settings/settings.module';
import { SplashScreenModule } from './RefModules/_metronic/partials/layout/splash-screen/splash-screen.module';
import { DataService } from './services/data.service';
import { MeasurementService } from './services/measurement.service';
//import { AvatarModule } from 'ngx-avatars';
import { NgxUiLoaderConfig, NgxUiLoaderModule } from 'ngx-ui-loader';
// import { NgxSearchFilterModule } from 'ngx-search-filter';
import { NgJsonEditorModule } from 'ang-jsoneditor';
import { ColorPickerModule } from 'ngx-color-picker';
import { MaterialModule } from './shared/material.module';
import { CustomToastrComponent } from './shared/Toaster/custom-toastr/custom-toastr.component';
import { CustomToastrModule } from './shared/Toaster/custom-toastr/custom-toastr.module';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import {
    MsalGuard,
    MsalBroadcastService,
    MsalModule,
    MsalService,
    MSAL_GUARD_CONFIG,
    MSAL_INSTANCE,
    MSAL_INTERCEPTOR_CONFIG,
    MsalGuardConfiguration,
    MsalInterceptorConfiguration,
} from '@azure/msal-angular';
import { TranslocoRootModule } from './RefModules/new i18n/transloco-root.module';
import { ManagementModule } from './Modules/management/management.module';
import { SharedModule } from './shared/shared.module';
import { LandingIndexComponent } from './components/landing-index/landing-index.component';
import { OrganizationDataService } from './services/organization-data.service';
import { EmailSenderService } from './services/email-sender.service';
import { InstanceDataService } from './services/instance-data.service';
import { EncrytionDecryptionHelperService } from './services/encrytion-decryption-helper.service';
import { HttpApiCallInterceptor } from './guards/http-api-call.interceptor';
import { TranslocoModule } from '@jsverse/transloco';
import { CommonComponentModule } from './components/common-component.module';
import { environment } from 'src/environments/environment';
import { Configuration, InteractionType, LogLevel, PublicClientApplication } from '@azure/msal-browser';
import { SharedPipeModule } from './shared/shared-pipe.module';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { ErrorInterceptor } from './guards/error.interceptor';
import { EnvironmentService } from './services/environment.service';
import { providePrimeNG } from 'primeng/config';
import Aura from '@primeuix/themes/aura';

const ngxUiLoaderConfig: NgxUiLoaderConfig = {
    hasProgressBar: false,
    fgsColor: '#ffe203',
};

const isIE = window.navigator.userAgent.indexOf('MSIE ') > -1 || window.navigator.userAgent.indexOf('Trident/') > -1;

export function loggerCallback(logLevel: LogLevel, message: string) {
    console.log(message);
}

export function initializeMsal(msalService: MsalService): () => Promise<void> {
    return () => msalService.instance.initialize();
}

export function MSALInstanceFactory(environmentService: EnvironmentService): PublicClientApplication {
    // Changed return type
    var _config = environmentService.getConfig();
    const config: Configuration = {
        auth: {
            clientId: _config.clientId,
            authority: environment.b2cPolicies.authorities.signUpSignIn.authority,
            redirectUri: environment.redirectUri,
            postLogoutRedirectUri: environment.postLogoutRedirectUri,
            knownAuthorities: [environment.b2cPolicies.authorityDomain],
        },
        cache: {
            cacheLocation: 'localStorage',
            storeAuthStateInCookie: isIE,
        },
        system: {
            loggerOptions: {
                logLevel: LogLevel.Verbose,
                piiLoggingEnabled: false,
            },
        },
    };

    return new PublicClientApplication(config); // Removed type casting
}

export function MSALInterceptorConfigFactory(): MsalInterceptorConfiguration {
    const protectedResourceMap = new Map<string, Array<string>>();

    protectedResourceMap.set(environment.uri, environment.scopes);
    console.log('protectedResourceMap :', protectedResourceMap);
    return {
        interactionType: InteractionType.Popup,
        protectedResourceMap,
    };
}

export function MSALGuardConfigFactory(): MsalGuardConfiguration {
    return {
        interactionType: InteractionType.Popup,
        authRequest: {
            scopes: [...environment.scopes],
        },
        loginFailedRoute: '/login-failed',
    };
}

export const apiConfig: { scopes: string[]; uri: string } = {
    scopes: environment.scopes,
    uri: environment.uri,
};

// export const appInsights = new ApplicationInsights({
//     config: {
//         instrumentationKey: environment.instrumentationKey,
//         /* ...Other Configuration Options... */
//     },
// });
export function appInsightsFactory(configService: EnvironmentService): ApplicationInsights {
    const config = configService.getConfig();

    const appInsights = new ApplicationInsights({
        config: {
            instrumentationKey: config.instrumentationKey,
            enableAutoRouteTracking: false,
            disableTelemetry: true, // 👈 THIS IS THE KEY
        },
    });
    if (environment.enableAppInsights) {
        appInsights.loadAppInsights();
        // appInsights.trackPageView();
    }
    // appInsights.loadAppInsights();

    return appInsights;
}

@NgModule({
    declarations: [
        AppComponent,
        LayoutComponent,
        FooterComponent,
        SocialMediaFooterComponent,
        LandingComponent,
        LandingHeaderComponent,
        LandingHerosComponent,
        ProductDetailsComponent,
        LandingIndexComponent,
    ],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        ToastrModule.forRoot({
            timeOut: 2500,
            //    positionClass: 'toast-top-center',
            positionClass: 'toast-bottom-right',
            preventDuplicates: true,
            progressBar: true,
            toastComponent: CustomToastrComponent,
        }),
        SplashScreenModule,
        HttpClientModule,
        HighlightModule,
        NgbModule,
        ClipboardModule,
        FormsModule,
        ReactiveFormsModule,
        AppRoutingModule,
        MsalModule,
        HomeModule,
        InformateModule,
        MaterialModule,
        MatTabsModule,
        CommonModule,
        SettingsModule,
        //AvatarModule,
        ManagementModule,
        NgxUiLoaderModule.forRoot(ngxUiLoaderConfig),
        // NgxSearchFilterModule,
        NgJsonEditorModule,
        ColorPickerModule,
        CustomToastrModule,
        TranslocoRootModule,
        CommonComponentModule,
        SharedModule,
        SharedPipeModule,
        TranslocoModule,
    ],
    providers: [
        // {
        //     provide: HTTP_INTERCEPTORS,
        //     useClass: MsalInterceptor,
        //     multi: true,
        // },
        {
            provide: MSAL_INSTANCE,
            useFactory: MSALInstanceFactory,
            deps: [EnvironmentService], // 👈 THIS WAS MISSING
        },
        {
            provide: MSAL_GUARD_CONFIG,
            useFactory: MSALGuardConfigFactory,
        },
        {
            provide: MSAL_INTERCEPTOR_CONFIG,
            useFactory: MSALInterceptorConfigFactory,
        },
        {
            provide: APP_INITIALIZER,
            useFactory: initializeMsal,
            deps: [MsalService],
            multi: true,
        },
        {
            provide: HIGHLIGHT_OPTIONS,
            useValue: {
                coreLibraryLoader: () => import('highlight.js/lib/core'),
                languages: {
                    xml: () => import('highlight.js/lib/languages/xml'),
                    typescript: () => import('highlight.js/lib/languages/typescript'),
                    scss: () => import('highlight.js/lib/languages/scss'),
                    json: () => import('highlight.js/lib/languages/json'),
                },
            },
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: HttpApiCallInterceptor,
            multi: true,
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: ErrorInterceptor,
            multi: true,
        },
        {
            provide: ApplicationInsights,
            useFactory: appInsightsFactory,
            deps: [EnvironmentService], // 👈 Inject service
        },
        providePrimeNG({
            theme: {
                preset: Aura,
            },
        }),
        MsalService,
        MsalGuard,
        MsalBroadcastService,
        DataService,
        MeasurementService,
        DatePipe,
        OrganizationDataService,
        EmailSenderService,
        InstanceDataService,
        EncrytionDecryptionHelperService,
        NgbActiveModal,
    ],
    bootstrap: [AppComponent],
    exports: [SettingsModule],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AppModule {}
